import { render, staticRenderFns } from "./ArchiveItemModal.vue?vue&type=template&id=3591ff86&"
import script from "./ArchiveItemModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports